<template>
  <section class="banner">
    <div class="container">
      <a-typography-title :level="1">
        SchedulX<br>
        云原生智能运维平台
      </a-typography-title>
      <a-typography-paragraph>
        {{
          'SchedulX是一款具备先进Serverless和FinOps能力的智能运维平台，' +
          '帮助基于任意语言开发的Web系统在零代码改造的前提下实现Serverless化，' +
          '通过全自动化部署发布、性能维护、稳定性治理，减少90%以上的运维工作，整体IT成本节省可达60%以上。'
        }}
      </a-typography-paragraph>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_1"
                  @click="$RQ.GoGSS()">
          免费体验
        </a-button>
        <a-button type="link" class="button_n_1"
                  @click="$Store.Page().openModal('modalFormCollection','demo')">
          预约咨询
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'product_banner'
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productSchedulX/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 120px 0 50px;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(justify, @banner_title, @color_white, @banner_title, true);
}

div.ant-typography {
  max-width: 450px;
  margin: 20px 0 0;
  .font(justify, @text+@line, @color_white, @text);
}

.ant-space {
  margin-top: 20px;
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 80px 0 30px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(justify, @banner_title_mo, @color_white, @banner_title_mo, true);
  }
  
  div.ant-typography {
    margin: 10px 0 0;
    .font(justify, @text_mo+@line_mo, @color_white, @text_mo);
  }
  
  .ant-space {
    margin-top: 10px;
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>